import { useGLTF } from "@react-three/drei"
import { Suspense, useEffect, useRef } from "react";


const LoadModel = ({
    name,
    url,
    visible,
    rotation = [0, 0, 0]
}) => {
    const model = useGLTF(url);
    const groupRef = useRef();


    return (
        <Suspense fallback={null} key={name}>
            {visible &&
                <group ref={groupRef} rotation={rotation}>
                    <primitive object={model.scene} />
                </group>
            }
        </Suspense>
    );
}

export default LoadModel